import React from "react";
import { BackendFailureAlert, isUserAuthenticated, isUserValid } from "../../platform-core";
import { ErrorBoundary } from "react-error-boundary";
import { createTheme, getDesignTokens, Paper, ThemeProvider } from "@platform/style";

interface PlatformSecureProps {
  children: React.ReactNode;
}

const fallbackRenderer = ({ error, resetErrorBoundary }: any) => {
  const valid: boolean = isUserValid();
  const theme = createTheme(getDesignTokens("light"));

  let message = undefined;

  if (!valid) {
    message = "Your user account is not configured correctly. Please contact your administrator.";
  }

  return (
    <ThemeProvider theme={theme}>
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "center",
          paddingTop: "20%",
          flexDirection: "column",
          backgroundColor: "background.default",
          height: "100%",
        }}
      >
        <BackendFailureAlert
          failures={[
            {
              message: message,
              retryFunction: valid ? resetErrorBoundary : undefined,
              exceptionInformation: error.message,
              reportable: valid,
            },
          ]}
        />
      </Paper>
    </ThemeProvider>
  );
};

export const PlatformSecure = ({ children }: PlatformSecureProps) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean>(false);

  React.useEffect(() => {
    (async () => {
      const authenticated = await isUserAuthenticated();
      setIsAuthenticated(authenticated);
    })();
  }, []);

  return (
    <ErrorBoundary fallbackRender={fallbackRenderer}>{isAuthenticated && children}</ErrorBoundary>
  );
};
